import { MenuItem } from '@mui/material';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useTranslation } from 'react-i18next';
import { useEndSessionControl } from 'features/toolbar/toolbar/controls/end-call/useEndSessionControl';
import { useTheme } from '@mui/material/styles';

const EndCallControl = () => {
  const { t } = useTranslation('room');

  const theme = useTheme();

  const {
    leaveSession,
    endSession,
    endSessionAvailable,
    icon,
    leaveSessionAvailable,
    singleControlHandler,
    singleControlLabel,
    menuLabel,
    availableControls,
    showNestedControls,
  } = useEndSessionControl();

  if (showNestedControls) {
    return (
      <ToolbarMenuItem
        data-testid="end-call-control-menu"
        menu
        overlay={menuLabel}
        ariaLabel={menuLabel}
        icon={icon}
        id="end-call"
        sx={{
          '& .MuiButtonBase-root': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.error.dark,
            },
          },
        }}
      >
        {leaveSessionAvailable ? (
          <MenuItem onClick={leaveSession}>
            {t('toolbar.end_session_options.leave_session')}
          </MenuItem>
        ) : null}
        {endSessionAvailable ? (
          <MenuItem
            sx={{
              color: 'error.main',
            }}
            onClick={endSession}
          >
            {t('toolbar.end_session_options.end_session')}
          </MenuItem>
        ) : null}
      </ToolbarMenuItem>
    );
  }

  if (availableControls.some(Boolean)) {
    return (
      <ToolbarMenuItem
        data-testid="end-call-control"
        overlay={singleControlLabel}
        ariaLabel={singleControlLabel}
        icon={icon}
        id="end-call"
        onClick={singleControlHandler}
        className="EndCallControl-root"
        sx={{
          '& .MuiButtonBase-root': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.error.dark,
            },
          },
        }}
      />
    );
  }

  return null;
};

export default EndCallControl;
